// export default "https://app.happyroster.com/beer-league-backend/public/";

export default "https://sjsbackkend.calidig.com/";

// export default "http://127.0.0.1:8000/";
